export class AuthenticatedUserService {
    /* @ngInject */
    constructor($http, $resource, egUrlService, $log, $q) {
        this.egUrlService = egUrlService;
        this.$http = $http;
        this.$log = $log;
        this.$q = $q;
        let url = this.egUrlService.url('/authentication/authenticatedUsers/:id');
        this.authenticatedUserWebService = $resource(url, null, {
            getInstallationsForUser: {
                url: this.egUrlService.url('/authentication/authenticatedUsers/:id/installations'),
                method: 'GET',
                params: {id: '@id'},
                isArray: true
            },
            getUserTypes: {
                url: this.egUrlService.url('/authentication/authenticatedUsers/userTypes'),
                method: 'GET',
                isArray: true
            }
        });
    }

    get(id) {
        return this.authenticatedUserWebService.get({id: id}).$promise;
    }

    getInstallationsForUser(id) {
        return this.authenticatedUserWebService.getInstallationsForUser({id: id}).$promise;
    }

    getUserTypes() {
        return this.authenticatedUserWebService.getUserTypes().$promise;
    }

    logout(sessionId) {
        let url = this.egUrlService.url('/authentication/userSessions/logout?sessionId={{sessionId}}', {
            sessionId: sessionId
        });

        return this.$http.post(url)
            .then(response => { this._requestSuccess(response); }, response => { this._requestError(response); });
    }

    _requestSuccess(response) {
        return response.data;
    }

    _requestError(response) {
        return this.$q.reject(response.data);
    }

    getAuthenticatedUsers(){
        let url = this.egUrlService.url('/authentication/userSessions');
        return this.$http.get(url)
            .then(response => response.data);
    }

    getAuthenticatedUserByUsername(username) {
        let url = this.egUrlService.url('/authentication/authenticatedUsers');
        return this.$http.get(url, {params: {'username' : username }});
    }

    canActivate(username) {
        let url = this.egUrlService.url(`/authentication/authenticatedUsers/${username}/canActivate`);
        return this.$http.get(url);
    }
}